import React from 'react'
import './styles.scss'
import fixedIco from './../../images/fixed-ico.svg';
import eSignatureIco from './../../images/esignature-ico.svg';
import aedIco from './../../images/aed-ico.svg';
import customerIco from './../../images/customer-ico.svg';
import shieldIco from './../../images/shield-ico.svg';
import directIco from './../../images/direct-ico.svg';

const Benefits = () => {

    return (
        <section className="benefits">
            <div className="wrapper">
                <div className="col">
                    <img src={ directIco } alt="" />
                    <p>
                        Electronic Direct Debit Authorization
                    </p>
                </div>
                <div className="col hands">
                    <img src={ fixedIco } alt="" />
                    <p>
                        Fixed Instalment
                    </p>
                </div>
                <div className="col">
                    <img src={ eSignatureIco } alt="" />
                    <p>
                        E-Signature up to 50,000.00 AED
                    </p>
                </div>
                <div className="col">
                    <img src={ aedIco } alt="" />
                    <p>
                        Leasing without down payment
                    </p>
                </div>
                <div className="col">
                    <img src={ customerIco } alt="" />
                    <p>
                        Customer portal access
                    </p>
                </div>
                <div className="col">
                    <img src={ shieldIco } alt="" />
                    <p>
                        All-risk insurance dedicated to equipment
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Benefits;